<script setup>
import { ref, reactive } from "vue";

defineProps({
    modelValue: String,
})

const emit = defineEmits(['update:modelValue'])

const stars = [
    { id: 'one', value: 1, class: 'one two three four five' },
    { id: 'two', value: 2, class: 'two three four five' },
    { id: 'three', value: 3, class: 'three four five' },
    { id: 'four', value: 4, class: 'four five' },
    { id: 'five', value: 5, class: 'five' }]

const isHovered = ref(false)

const classObject = reactive({
    'w-4': true,
    ' h-4': true,
    'ms-1': true,
    'cursor-pointer': true,
    'text-gray-700': isHovered,
})

let stop = true;

let emitValue = function (x) {    
    stop = false;
    for (let i = 1; i <= 5; i++) {

        if (i <= x) {
            document.getElementsByName(i)[0].style.color = 'red';
            document.getElementsByName(i)[0].style.opacity = '1';
        }
        else {
            document.getElementsByName(i)[0].style.color = 'grey';
            document.getElementsByName(i)[0].style.opacity = '0.2';
        }
    }

    emit('update:modelValue', x);
}

let hoverFunction = function (x) {
    for (let i = 1; i <= 5; i++) {
        if (i <= x) {
            document.getElementsByName(i)[0].style.color = 'red';
        }
        else {
            document.getElementsByName(i)[0].style.color = 'grey';
        }
    }
}

let leaveFunction = function (x) {
    if (stop === true) {
        for (let i = 1; i <= 5; i++) {
            document.getElementsByName(i)[0].style.color = 'gray';
        }
    }
}
</script>

<template>
    <div class="flex items-center justify-center">
        <span v-for="item in stars" :key="item.id">
            <label :for="item.id">
                <input type="radio" :value="modelValue" @click="emitValue(item.value)" :name="item.id" :id="item.id" class="hidden">
                    <svg  @mouseover="hoverFunction(item.value)"
                        @mouseleave="leaveFunction(item.value)" :class="[classObject, item.class]" :name="item.value"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                        <use href="#ic-star" />
                    </svg>
            </label>
        </span>
    </div>
</template>
